/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_b79d991c"]'><div :class='["checkbox-demo"]'><view-desc>默认勾选：{{ checkboxValue }}</view-desc><div :class='["cube-checkbox-example"]'><cube-checkbox :value="checkboxValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkboxValue", "__mpx_event__", ["value"], undefined]])'>Default Checked</cube-checkbox></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_b79d991c"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_b79d991c"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_b79d991c"}
  /** script content **/
  require("./default-checked.mpx.js?isComponent&outputPath=components%2Fdefault-checkedb79d991c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./default-checked.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdefault-checkedb79d991c%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_b79d991c"],
    ctorType: "component",
    outputPath: "components/default-checkedb79d991c/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-checkbox':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>